module.exports = __webpack_public_path__ + "img/sunburst.8fffb3a3.png";